module.exports = __webpack_public_path__ + "img/game08.73f9f41c.png";